export default "__VITE_ASSET__moLHDSr7__"